import React, {ReactNode} from "react";

interface FormSectionProps {
    label: string
    children: ReactNode
    header?: ReactNode
}

const FormSection = function FormSection({
                                             label,
                                             children,
                                            header
                                         }: FormSectionProps) {
    return <section title={label}>
        <div style={{
            display: 'flex',
            alignItems: 'center',
            padding: '2em 1em',
            color: 'var(--core-primary-highlight-color)',
            height: '2em'
        }}>
            <span>{label}</span>
             {header && header}
        </div>
        <div style={{paddingBottom: '1em'}}>
            {children}
        </div>
    </section>
}

export {
    FormSection
}
